// File status tags (V0.4.5): one status per file plus a separate "To review" flag. Older versions of a document show
// as Outdated without being tagged; a current version that has older ones shows as Latest until someone tags it.
export type StatusTag = 'latest' | 'for_construction' | 'approved' | 'draft' | 'info' | 'outdated' | 'superseded';

export const STATUS_TAGS: { key: StatusTag; label: string; cls: string }[] = [
  { key: 'latest', label: '✓ Latest', cls: 'st-latest' },
  { key: 'for_construction', label: 'For construction', cls: 'st-ifc' },
  { key: 'approved', label: 'Approved', cls: 'st-approved' },
  { key: 'draft', label: 'Draft', cls: 'st-draft' },
  { key: 'info', label: 'For info only', cls: 'st-info' },
  { key: 'outdated', label: 'Outdated', cls: 'st-old' },
  { key: 'superseded', label: 'Superseded by…', cls: 'st-old' },
];
export const tagOf = (k: string | null | undefined) => STATUS_TAGS.find((t) => t.key === k) ?? null;

export type Taggable = {
  id: string;
  original_name: string;
  status_tag?: string | null;
  review_flag?: boolean | null;
  superseded_by?: string | null;
  notes?: string | null;
  note_by_name?: string | null;
  note_at?: string | null;
  is_current?: boolean | null;
};

/** The status to show: the file's own tag, else Outdated for an older version, else Latest when it has older versions. */
export function shownStatus(f: Taggable, hasOlder = false): StatusTag | null {
  if (f.status_tag && tagOf(f.status_tag)) return f.status_tag as StatusTag;
  if (f.is_current === false) return 'outdated';
  if (hasOlder) return 'latest';
  return null;
}
export const isOld = (s: StatusTag | null) => s === 'outdated' || s === 'superseded';
